<div class="wingsmed-forbidden-error" *ngIf="error === true">
    {{errorMessage}}
</div>
<div class="row wingsmed-row">
    <app-dynamic-form (saveDynamicFormEvent)="saveData($event)" *ngIf="loading === false" [questions]="questions"></app-dynamic-form>
</div>